import {
  Briefcase,
  CheckCircle2,
  Clock3,
  XCircle,
} from "lucide-react";

import { normalizeStatus } from "../../utils/applicationStatus";
import type { CandidateApplication } from "../../types/candidateDashboard.types";

interface ApplicationStatsProps {
  applications: CandidateApplication[];
}

export default function ApplicationStats({
  applications = [],
}: ApplicationStatsProps) {
  const normalizedApplications = Array.isArray(applications)
    ? applications.map((item) => ({
      ...item,
      normalizedStatus: normalizeStatus(item?.status),
    }))
    : [];

  const stats = [
    {
      title: "Total Applied",
      value: normalizedApplications.length,
      icon: Briefcase,
      iconStyle: "bg-blue-50 text-blue-600",
      valueStyle: "text-slate-900",
    },
    {
      title: "Pending",
      value: normalizedApplications.filter(
        (item) =>
          item.normalizedStatus === "PENDING" ||
          item.normalizedStatus === "APPLIED" ||
          item.normalizedStatus === "UNDER_REVIEW" ||
          item.normalizedStatus === "ATS SCREENING"
      ).length,
      icon: Clock3,
      iconStyle: "bg-amber-50 text-amber-600",
      valueStyle: "text-slate-900",
    },
    {
      title: "Selected",
      value: normalizedApplications.filter(
        (item) => item.normalizedStatus === "SELECTED"
      ).length,
      icon: CheckCircle2,
      iconStyle: "bg-emerald-50 text-emerald-600",
      valueStyle: "text-slate-900",
    },
    {
      title: "Rejected",
      value: normalizedApplications.filter(
        (item) => item.normalizedStatus === "REJECTED"
      ).length,
      icon: XCircle,
      iconStyle: "bg-red-50 text-red-500",
      valueStyle: "text-slate-900",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2.5 lg:grid-cols-4">
      {stats.map((item) => {
        const Icon = item.icon;

        return (
          <div
            key={item.title}
            className="flex items-center gap-3.5 rounded-xl border border-slate-200 bg-white px-4 py-5 shadow-sm transition hover:border-slate-300 hover:shadow-md"
          >
            <div
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${item.iconStyle}`}
            >
              <Icon size={20} strokeWidth={2} />
            </div>

            <div className="min-w-0">
              <p className={`text-2xl font-bold leading-none tracking-tight ${item.valueStyle}`}>
                {item.value}
              </p>

              <p className="mt-1.5 truncate text-xs font-medium text-slate-500">
                {item.title}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}